import PropTypes from "prop-types";

import { Badge } from "@/components/ui/badge";

const LeadStatusBadge = ({ status }) => (
  <Badge variant="outline" className="tw:gap-1.5">
    {status.color && (
      <span
        className="tw:inline-block tw:size-2 tw:rounded-full"
        style={{ backgroundColor: status.color }}
      />
    )}
    {status.name}
  </Badge>
);

LeadStatusBadge.propTypes = {
  status: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
};

export default LeadStatusBadge;
